import AnimationClip from '../AnimationClip';
import { Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import { delay } from '../../../Utility/Task/TaskQueue';
import Point from '../../../Utility/Point';
import ColorFilter from '../../../Component/ColorFilter';

export class ButtonBounceLoop extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        // "Remove" the brightness.
        const colorFilter = gameObject.getComponent(ColorFilter);
        if (colorFilter) {
            const colorTween: Tween = this.getTween(colorFilter);
            colorTween.to({ brightness: 1 }, 100).start(this.elapsedTime);
        }

        const element = gameObject.getComponent(ElementComponent);

        const scaleTween: Tween = this.getTween(element.layout.scale);
        const scale1 = new Point(0.9 * meta.scale.x, meta.scale.y);
        const scale2 = new Point(1.1 * meta.scale.x, 1.1 * meta.scale.y);
        const scale3 = new Point(1.1 * meta.scale.x, 0.95 * meta.scale.y);
        const scale4 = new Point(meta.scale.x, meta.scale.y);

        while (true) {
            yield* this.tweenTo(scaleTween, scale1, 200);
            yield* this.tweenTo(scaleTween, scale2, 200);
            yield* this.tweenTo(scaleTween, scale3, 150);
            yield* this.tweenTo(scaleTween, scale4, 200);
            yield* delay(1000);
        }
    }

    private *tweenTo(
        tween: Tween,
        scale: Point,
        duration: number
    ): IterableIterator<number> {
        tween.to({ 0: scale.x, 1: scale.y }, duration);
        yield* this.startTween(tween);
    }
}
